import { render, staticRenderFns } from "./boxofficeRecordDetail.vue?vue&type=template&id=f510459e&scoped=true&"
import script from "./boxofficeRecordDetail.vue?vue&type=script&lang=js&"
export * from "./boxofficeRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./boxofficeRecordDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./boxofficeRecordDetail.vue?vue&type=style&index=1&id=f510459e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f510459e",
  null
  
)

export default component.exports